import React, {useState} from 'react'
import {useMatchMedia} from 'utils/hooks/useMatchMedia'
import {useAuth} from 'attendee/Auth/Providers/AuthProvider'
import {ProfileLinks} from 'attendee/theme/Header/ProfileLinks'
import {GuestNavActions} from 'attendee/theme/Header/GuestNavActions'
import {useTheme} from 'attendee/theme/ThemeProvider'
import {Show} from 'utils/ui/Show'
import {useNavigate} from 'react-router-dom'
import {routes} from 'routes/routes'
import FullscreenIcon from '@mui/icons-material/Fullscreen'
import {useQueryParams} from 'utils/lib/url'
import {LanguageSelector} from 'i18n/LanguageSelector'
import {useI18n} from 'i18n/I18nContext'
import {withLocalePath} from 'i18n/localePaths'

export const Header = () => {
  const {user} = useAuth()
  const navigate = useNavigate()
  const {locale, t} = useI18n()
  const {term} = useQueryParams()
  const {SidebarHandle} = useTheme()
  const isNarrowHeader = useMatchMedia('(max-width:767px)')

  const [isFullScreen, setIsFullScreen] = useState(false)
  const handleToggleFullScreen = () => {
    if (!isFullScreen) {
      enterFullScreen()
    } else {
      exitFullScreen()
    }
  }

  const enterFullScreen = () => {
    const docElement = document.documentElement

    if (docElement.requestFullscreen) {
      docElement.requestFullscreen()
    } else if ((docElement as any).mozRequestFullScreen) {
      ;(docElement as any).mozRequestFullScreen()
    } else if ((docElement as any).webkitRequestFullscreen) {
      ;(docElement as any).webkitRequestFullscreen()
    }
    setIsFullScreen(true)
  }

  const exitFullScreen = () => {
    if (document.exitFullscreen) {
      document.exitFullscreen()
    } else if ((document as any).mozCancelFullScreen) {
      ;(document as any).mozCancelFullScreen()
    } else if ((document as any).webkitExitFullscreen) {
      ;(document as any).webkitExitFullscreen()
    }
    setIsFullScreen(false)
  }

  const [searchTerm, setSearchTerm] = useState<string>(term ?? '')
  const runSearch = () => {
    const base = withLocalePath(locale, routes.search)
    navigate(`${base}?term=${encodeURIComponent(searchTerm)}`)
  }

  const handleSearchKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      runSearch()
    }
  }

  return (
    <div className="app__header__area">
      <div className="app__header-inner">
        <div className="app__header-row-main">
          <div className="app__header-left">
            <button
              onClick={SidebarHandle}
              id="sidebar__active"
              aria-label={t('header.sidebarToggleAria')}
            >
              <div className="bar-icon-2">
                <span></span>
                <span></span>
                <span></span>
              </div>
            </button>

            <div className="app__herader-input p-relative">
              <input
                type="search"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                onKeyDown={handleSearchKeyDown}
                placeholder={t('header.searchPlaceholder')}
              />
              <button
                type="button"
                onClick={runSearch}
                aria-label={t('header.searchButtonAria')}
                className="app__header-search-submit"
              >
                <i className="flaticon-loupe"></i>
              </button>
            </div>
          </div>

          <div className="app__header-right">
            <div className="app__header-action">
              <ul>
                <LanguageSelector compact={isNarrowHeader} />
                <li className="full-screen-button">
                  <button
                    type="button"
                    onClick={handleToggleFullScreen}
                    aria-label={t('header.fullScreenAria')}
                  >
                    <div className="nav-item">
                      <div className="notification__icon">
                        <FullscreenIcon />
                      </div>
                    </div>
                  </button>
                </li>
              </ul>
            </div>

            <Show if={user}>
              <ProfileLinks />
            </Show>
            <Show if={!user}>
              <GuestNavActions stacked={isNarrowHeader} />
            </Show>
          </div>
        </div>
      </div>
    </div>
  )
}
